import { render, staticRenderFns } from "./Dizhi.vue?vue&type=template&id=68eb84ce&"
import script from "./Dizhi.vue?vue&type=script&lang=js&"
export * from "./Dizhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports